import { Dialog } from "construct-ui";
import SingleSelectComponent from "../single-select/single-select.component";
import ViewBase from "../../views/view-base.view";
import udfManagementModel from "../../models/udf-management/udf-management.modal";

/**
 * Model UDF Add & Edit Dialog
 * 
 * 
 * 
 * @author cmc.nttruong1
 */
export default function ModelUDFAddEditDialog() {
  ViewBase.call(this);

  let attributeTypeOptionList = [];

  const ATTRIBUTE_TYPE_SPECIAL = 'LIST_VALUE';
  const FORM_ID = 'ModelUDFAddEditDialogForm';

  const DEFAULT_MODEL_UDF_DETAILS = {
    encryptedUdfId: '',
    gscmDivision: '',
    attributeId: '',
    attributeName: '',
    attributeType: '',
    description: '',
    listValues: [],
  };

  let isEdit = false;
  let isListValues = false;

  let modelUDF = structuredClone(DEFAULT_MODEL_UDF_DETAILS);
  let modelUDFBeforeEdit = structuredClone(modelUDF);

  const getListAttributeType = () => {
    udfManagementModel.getModelUDFType()
      .then((result) => {
        attributeTypeOptionList = [];
        if (result !== null && result !== undefined) {
          attributeTypeOptionList = result;
        }
      })
      .catch((error) => {
        this.handleError(error)
      })
  }

  const getTitle = (isEdit) => {
    let title = isEdit ? this.getText('LT00000926', 'Edit Model UDF') : this.getText('LT00000927', 'Register Model UDF');
    return title;
  }

  const updateModelUDF = (onSaveComplete, modelUDF) => {
    let _valid = _inputValidation();
    if (_valid) {
      return udfManagementModel.updateModelUdf(_formatDataBeforeUpdate(modelUDF))
        .then(onSaveComplete)
        .catch(error => {
          this.handleError(error);
        });
    }
  }

  const addModelUDF = (onSaveComplete, modelUDF) => {
    let _valid = _inputValidation();
    if (_valid) {
      modelUDF.listValues = (modelUDF.attributeType !== ATTRIBUTE_TYPE_SPECIAL)
        ? [] : modelUDF.listValues.filter((item) => item.name).map((item) => ({ name: item.name }));

      return udfManagementModel.addModelUdf(modelUDF)
        .then(onSaveComplete)
        .catch(error => {
          this.handleError(error);
        });
    }
  }

  // Placed here because addModelUDF and updateModelUDFs are variables and they have to exists before variable declaration
  const onSubmitFunctions = [addModelUDF, updateModelUDF];

  const _formatDataBeforeUpdate = () => {
    modelUDF.listValues = (modelUDF.attributeType !== ATTRIBUTE_TYPE_SPECIAL)
      ? [] : modelUDF.listValues.filter((item) => item.name).map((item) => ({ name: item.name }));

    return Object.assign({
      "encryptedUdfId": modelUDF.encryptedUdfId,
      "attributeName": modelUDF.attributeName,
      "attributeType": modelUDF.attributeType,
      "description": modelUDF.description,
      "listValues": modelUDF.listValues
    });
  }

  const assignListValues = (list) => {
    modelUDF.listValues = list;
  }

  const hasChanges = () => {
    modelUDF.listValues = modelUDF.listValues.filter((item) => !!item.name);
    if (JSON.stringify(modelUDFBeforeEdit) !== JSON.stringify(modelUDF)) {
      return true;
    }
    return false;
  }

  const handleOnClose = (onClose) => () => {
    if (!hasChanges() || confirm(this.getText('EM00000776', 'Changes you made may not be saved'))) {
      onClose();
    }
  }

  const _setDetail = (id) => {
    udfManagementModel.getModelUdf(id).then((result) => {
      modelUDF = result;
      modelUDFBeforeEdit = structuredClone(modelUDF);
    })
  }

  const _inputValidation = () => {
    if (!modelUDF.gscmDivision) {
      this.showErrorMessage(this.getText("LT00000857", "Please select a GSCM division"));
      return false;
    }
    if (!modelUDF.attributeName) {
      this.showErrorMessage(this.getText("LT00000939", "Please input Attribute Name"));
      return false;
    }
    if (!modelUDF.description) {
      this.showErrorMessage(this.getText("LT00000937", "Please input Description"));
      return false;
    }
    if (!modelUDF.attributeType) {
      this.showErrorMessage(this.getText("LT00000938", "Please input Attribute Type"));
      return false;
    }
    if (modelUDF.attributeType === ATTRIBUTE_TYPE_SPECIAL && modelUDF.listValues.length == 0) {
      this.showErrorMessage(this.getText("LT00000936", "Please input at least one List Values"));
      return false;
    }

    return true;
  }

  return {
    oninit: (vnode) => {
      getListAttributeType();

      if (!!vnode.attrs.data) {
        let data = vnode.attrs.data;
        _setDetail(data.encryptedUdfId);

        isListValues = data.attributeType === ATTRIBUTE_TYPE_SPECIAL;
      }

      isEdit = !!vnode.attrs.data;
    },
    view: (vnode) => {
      return [
        m(Dialog, {
          title: getTitle(isEdit),
          isOpen: true,
          onClose: vnode.attrs.onClose,
          closeOnEscapeKey: true,
          closeOnOutsideClick: false,
          content: m(`form#${FORM_ID}.form-control`,
            m('.row.g-2',
              m('.col-12.d-flex',
                m("label.form-label.mandatory.text-nowrap",
                  { style: { width: "30%" } },
                  this.getText("LT00000241", "GSCM Division")),
                m(SingleSelectComponent, {
                  filterable: false,
                  disabled: !!vnode.attrs.data,
                  id: "gscmDivision",
                  items: vnode.attrs.gscmDivisionOptionList,
                  selectedItem: vnode.attrs.gscmDivisionOptionList.find((e) => e.code === modelUDF.gscmDivision),
                  onSelect: (s) => {
                    modelUDF.gscmDivision = s.code;
                  },
                  required: true,
                })
              ),
              vnode.attrs.data &&
              m('.col-12.d-flex',
                m('label.form-label.mandatory.text-nowrap',
                  { style: { width: "30%" } },
                  this.getText('LT00000923', 'Attribute ID')),
                m('input.form-control', {
                  type: 'text',
                  value: modelUDF.attributeId,
                  onchange: (e) => {
                    modelUDF.attributeId = e.target.value;
                  },
                  disabled: true,
                })
              ),
              m('.col-12.d-flex',
                m('label.form-label.mandatory.text-nowrap',
                  { style: { width: "30%" } },
                  this.getText('LT00000922', 'Attribute Name')),
                m('input.form-control', {
                  type: 'text',
                  disabled: modelUDF.attributeId.includes("GSCM") || modelUDF.attributeId.includes('RHQ'),
                  required: true,
                  value: modelUDF.attributeName,
                  onchange: (e) => {
                    modelUDF.attributeName = e.target.value;
                  }
                })
              ),
              m('.col-12.d-flex',
                m('label.form-label.mandatory.text-nowrap',
                  { style: { width: "30%" } },
                  this.getText('LT00000012', 'Description')),
                m('textarea#txtContent.form-control.form-check-input', {
                  required: true,
                  disabled: modelUDF.attributeId.includes("GSCM") || modelUDF.attributeId.includes('RHQ'),
                  value: modelUDF.description || '',
                  onchange: (e) => {
                    modelUDF.description = e.target.value;
                  },
                  style: "height: 84px; width: 100%; opacity: 1;",
                })
              ),
              m('.col-12.d-flex',
                m('label.form-label.mandatory.text-nowrap',
                  { style: { width: "30%" } },
                  this.getText("LT00000924", "Attribute Type")),
                m(SingleSelectComponent, {
                  id: "attributeType",
                  items: attributeTypeOptionList,
                  selectedItem: attributeTypeOptionList.find((e) => e.code === modelUDF.attributeType),
                  onSelect: (s) => {
                    modelUDF.attributeType = s.code;
                    isListValues = s.code === ATTRIBUTE_TYPE_SPECIAL ? true : false;
                  },
                  required: true,
                  disabled: modelUDF.attributeId.includes("GSCM") || modelUDF.attributeId.includes('RHQ'),
                })
              ),
              isListValues &&
              m('.col-12.d-flex',
                m('label.form-label.mandatory.text-nowrap',
                  { style: { width: "30%" } },
                  this.getText("LT00001191", "Code List")),
                m('.card.w-100', { style: { maxHeight: '300px' } },
                  m('.card-body', { style: { overflowY: 'auto' } },
                    m('ul.vstack.gap-2.p-0.m-0',
                      modelUDF.listValues.map((item, index) => m('li',
                        m('div.row.g-1',
                          m('.col-1',
                            m('.d-flex.h-100.w-100.m-0.p-0.justify-content-center.align-items-center',
                              m('i.bi-dash-circle.text-danger.cursor-pointer.m-0', {
                                onclick: () => {
                                  modelUDF.listValues.splice(index, 1);
                                }
                              })
                            )
                          ),
                          m('.col-11',
                            m('input.form-control', 
                            { 
                              placeholder: this.getText('LT00000011', 'Name'),
                              value: item.name,
                              onchange: (e) => {
                                item.name = e.target.value;
                              },
                            })
                          )
                        )
                      )),
                      m('li',
                        m('div.row.g-1',
                          m('.col-12',
                            m('input.form-control', {
                              placeholder: this.getText('LT00001099', 'New list item name'),
                              onchange: (e) => {
                                modelUDF.listValues.push({ name: e.target.value });
                                e.target.value = '';
                                setTimeout(() => {
                                  e.target.scrollIntoView({ block: 'center', behavior: 'smooth' });
                                }, 0)
                              }
                            })
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          footer: m('.col-md-12.gap-2.d-flex.justify-content-end',
            m('button.btn.btn-primary', {
              type: 'button',
              onclick: () => {
                if (hasChanges()) {
                  onSubmitFunctions[+isEdit](vnode.attrs.onSaveComplete, modelUDF);
                } else {
                  this.showMessage(this.getText('EM00000755', 'No changes were made.'), this.getText('LT00000737', 'No Changes'))
                }
              }
            },
              isEdit ? this.getText('LT00000022', 'Save') : this.getText('LT00000090', 'Add')
            ),
            m('button.btn.btn-white', { type: 'button', onclick: handleOnClose(vnode.attrs.onClose) },
              this.getText('LT00000021', 'Close')
            )
          )
        }),
        this.getBaseViews()
      ]
    }
  }
}